(function() {
  'use strict';

  // ============================================================
  // 1. SCROLL REVEAL — IntersectionObserver
  // ============================================================
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealEls = document.querySelectorAll('.reveal');

  if (prefersReduced || !('IntersectionObserver' in window)) {
    revealEls.forEach(function(el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function(el) { io.observe(el); });
  }

  // ============================================================
  // 2. STICKY BAR — show after 30% scroll, hide near footer
  // ============================================================
  var stickyBar = document.getElementById('stickyBar');
  var footer = document.querySelector('.footer');
  var finalCta = document.getElementById('buy');

  function updateStickyBar() {
    if (!stickyBar) return;
    var scrolled = window.scrollY || window.pageYOffset;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    var scrollPct = docHeight > 0 ? (scrolled / docHeight) : 0;

    // hide near final-cta and footer (no double-CTA in same viewport)
    var hideZone = false;
    if (finalCta) {
      var rect = finalCta.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) hideZone = true;
    }
    if (footer) {
      var fRect = footer.getBoundingClientRect();
      if (fRect.top < window.innerHeight) hideZone = true;
    }

    if (scrollPct > 0.18 && !hideZone) {
      stickyBar.classList.add('visible');
    } else {
      stickyBar.classList.remove('visible');
    }
  }

  var stickyTicking = false;
  window.addEventListener('scroll', function() {
    if (!stickyTicking) {
      window.requestAnimationFrame(function() {
        updateStickyBar();
        stickyTicking = false;
      });
      stickyTicking = true;
    }
  }, { passive: true });
  updateStickyBar();

  // ============================================================
  // 3. FAQ — close other open items when one opens (accordion mode)
  // ============================================================
  var faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(function(item) {
    item.addEventListener('toggle', function() {
      if (item.open) {
        faqItems.forEach(function(other) {
          if (other !== item && other.open) other.open = false;
        });
      }
    });
  });


  // ============================================================
// 4. REPLACE #buy LINKS WITH CHECKOUT URL
// ============================================================
if (window.GWF_CHECKOUT_URL) {
  document.querySelectorAll('a[href="#buy"]').forEach(function(link) {
    link.setAttribute('href', window.GWF_CHECKOUT_URL);
  });
}

  // ============================================================
  // 4. SMOOTH SCROLL for in-page anchors (graceful)
  // ============================================================
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var href = link.getAttribute('href');
      if (href.length < 2) return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });
// ============================================================
  // 5. BEFORE / AFTER SLIDER
  // ============================================================
document.querySelectorAll('.gwf-before-after').forEach(function(wrapper) {
  var slider = wrapper.querySelector('.gwf-ba-slider');
  var after = wrapper.querySelector('.gwf-ba-after-wrap');
  var afterImg = wrapper.querySelector('.gwf-ba-after');
  var before = wrapper.querySelector('.gwf-ba-before');
  var divider = wrapper.querySelector('.gwf-ba-divider');

  if (!slider || !after || !afterImg || !divider) return;

function updateSlider(pct) {
    var wrapWidth = wrapper.offsetWidth;

    // Before-Bild (Template links): von rechts abschneiden
    before.style.clipPath = 'polygon(0 0, ' + pct + '% 0, calc(' + pct + '% - 45px) 100%, 0 100%)';

    // After-Wrap (Brand rechts): nimmt rechten Teil ein, fest
    after.style.width = '100%';
    after.style.clipPath = 'polygon(' + pct + '% 0, 100% 0, 100% 100%, calc(' + pct + '% - 45px) 100%)';

    // After-Bild immer volle Breite, linksbündig
    afterImg.style.width = wrapWidth + 'px';
    afterImg.style.position = 'absolute';
    afterImg.style.left = '0';
    afterImg.style.right = 'auto';

    // Divider an Slider-Position
    divider.style.left = pct + '%';
  }

  updateSlider(60);
  slider.value = 60;

  window.addEventListener('resize', function() {
    updateSlider(parseFloat(slider.value));
  });

  slider.addEventListener('input', function() {
    updateSlider(parseFloat(slider.value));
  });
});


// ============================================================
// 6. FLASHSALE COUNTDOWN
// ============================================================
var flashsaleDeadline = new Date(window.GWF_FLASHSALE_DEADLINE || "2026-06-14T19:00:00+02:00").getTime();

function padFlashsaleNumber(n) {
  return String(n).padStart(2, "0");
}

function updateFlashsaleCountdown() {
  var diff = Math.max(0, flashsaleDeadline - Date.now());

  var d = Math.floor(diff / 86400000);
  diff -= d * 86400000;

  var h = Math.floor(diff / 3600000);
  diff -= h * 3600000;

  var m = Math.floor(diff / 60000);
  diff -= m * 60000;

  var s = Math.floor(diff / 1000);

  document.querySelectorAll("[data-cd]").forEach(function(el) {
    el.innerHTML =
      (d > 0 ? "<b>" + padFlashsaleNumber(d) + "</b><span class='sep'>T</span>" : "") +
      "<b>" + padFlashsaleNumber(h) + "</b><span class='sep'>:</span>" +
      "<b>" + padFlashsaleNumber(m) + "</b><span class='sep'>:</span>" +
      "<b>" + padFlashsaleNumber(s) + "</b>";
  });

  document.querySelectorAll("[data-cd-short]").forEach(function(el) {
    el.textContent =
      (d > 0 ? d + "T " : "") +
      padFlashsaleNumber(h) + ":" +
      padFlashsaleNumber(m) + ":" +
      padFlashsaleNumber(s);
  });

  document.querySelectorAll("[data-cd-big]").forEach(function(el) {
    var day = el.querySelector("[data-d]");
    var hour = el.querySelector("[data-h]");
    var min = el.querySelector("[data-m]");
    var sec = el.querySelector("[data-s]");

    if (day) day.textContent = padFlashsaleNumber(d);
    if (hour) hour.textContent = padFlashsaleNumber(h);
    if (min) min.textContent = padFlashsaleNumber(m);
    if (sec) sec.textContent = padFlashsaleNumber(s);
  });
}

if (
  document.querySelector("[data-cd]") ||
  document.querySelector("[data-cd-short]") ||
  document.querySelector("[data-cd-big]")
) {
  updateFlashsaleCountdown();
  setInterval(updateFlashsaleCountdown, 1000);
}

})();